import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import { useSelector } from 'react-redux';
import IcoPassportRemember from '../../assets/icon-passport-remember.svg';
import IcoIneRemember from '../../assets/icon-ine-remember.svg';
import IconId from '../../assets//new-icons/id-min.png';
import IconPassport from '../../assets/new-icons/passport-min.png';
import { getDocumentTypeByInt } from '../../utils';
import usePageNavigation from '../../hooks/usePageNavigation';

function ImportantRememberPage() {
  const { guestList } = useSelector((state) => state.guests);
  const [passportGuestList, setPassportGuestList] = useState([]);
  const [idGuestList, setIdGuestList] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { navigateNextPage } = usePageNavigation();

  useEffect(() => {
    if (guestList.length > 0) {
      // TipoDocumento 2 = passport
      setPassportGuestList(guestList.filter((guest) => guest.TipoDocumento === '2'));
      setIdGuestList(guestList.filter((guest) => guest.TipoDocumento !== '2'));
    }
  }, [guestList]);

  const goTo = () => {
    navigateNextPage('Finished'); // Navega a la ruta "/about"
  };

  return (
    <div className="checking__important-remember d-flex flex-column h-100">
      <p className="mt-2 app-fs-33 app-fw-notosans-bold app-txt-granite text-center">{t('TXT_IMPORTANT')}</p>
      <p className="mb-0 app-fs-14 app-txt-granite-80-dark text-center">
        {t('TXT_IMPORTANT_SHOW')}
      </p>

      <div className="mt-3">
        <Card
          className={`mb-2 border-solid-1 transition-border-color border-radius-5 app-border-granite-80-light ${passportGuestList.length > 0 ? '' : 'd-none'}`}
        >
          <Card.Body className="text-center">
            <img
              src={IconPassport}
              alt="IconPassport"
              style={{ width: '45px' }}
            />
            <p className="app-fw-notosans-bold app-txt-granite-80-dark app-lh-h4 pt-2">
              {t('TXT_PASSPORTS_SCANNED')}
            </p>
            {passportGuestList.map((item) => (
              <div key={item.IDHuesped}>
                <p className="mb-1 text-center app-fs-14 app-lh-h5 app-txt-granite-80-dark">
                  {item.Nombre_Pila}
                  {' '}
                  {item.Nombre}
                </p>
              </div>
            ))}
          </Card.Body>
        </Card>

        <Card
          className={`border-solid-1 transition-border-color border-radius-5 app-border-granite-80-light ${idGuestList.length > 0 ? '' : 'd-none'}`}
        >
          <Card.Body className="text-center">
            <img
              src={IconId}
              alt="IconId"
              style={{ width: '50px' }}
            />
            <p className="app-fw-notosans-bold app-txt-granite-80-dark app-lh-h4">
              {t('TXT_IDS_SCANNED')}
            </p>
            {idGuestList.map((item) => (
              <div key={item.IDHuesped}>
                <p className="mb-1 text-center app-fs-14 app-lh-h5 app-txt-granite-80-dark">
                  {item.Nombre_Pila}
                  {' '}
                  {item.Nombre}
                </p>
              </div>
            ))}
          </Card.Body>
        </Card>
      </div>

      <div className="d-flex flex-grow-1 align-items-end pb-2">
        <p className="mt-2 app-fs-h5 app-fw-notosans-bold app-txt-granite-80 text-center">
          {t('TXT_HAPPY')}
        </p>
      </div>

      <div className="d-flex flex-grow-1 align-items-end pb-2">
        <Button
          variant=""
          className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
          onClick={goTo}
        >
          {t('TXT_BOTON_UNDERSTOOD')}
        </Button>
      </div>
    </div>
  );
}

export default ImportantRememberPage;
